import { chineseSignPages, chineseSignTable } from './chinese-sign-table'
import { venusSignTable } from './venus-sign-table'

import type { ChineseSignRange } from './chinese-sign-table'
import type { VenusSignRange } from './venus-sign-table'

export type SignCalculatorId = 'venus' | 'chinese'

export type SignResult = {
  sign: string,
  element?: string,
  link?: { label: string, href: string }
}

const findSignInYear = (ranges: VenusSignRange[] | undefined, day: number, month: number): string | null => {
  if (!ranges) return null
  const value = month * 100 + day
  const match = ranges.find(([from, to]) => {
    const [fromDay, fromMonth] = from.split('.').map(Number)
    const [toDay, toMonth] = to.split('.').map(Number)
    return value >= fromMonth * 100 + fromDay && value <= toMonth * 100 + toDay
  })
  return match ? match[2] : null
}

const findChineseSign = (day: number, month: number, year: number): SignResult | null => {
  const date = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
  const match: ChineseSignRange | undefined = chineseSignTable.find(([from, to]) => date >= from && date <= to)
  if (!match) return null
  const [, , animal, element] = match
  const page = chineseSignPages[animal]
  return { sign: page.label, element, link: { label: `Mehr zum Sternzeichen ${page.label}`, href: page.url } }
}

type SignCalculator = {
  headline: string,
  resultLabel: string,
  minDate: string,
  maxDate: string,
  rangeLabel: string,
  calculate: (day: number, month: number, year: number) => SignResult | null
}

// Weitere Rechner (z.B. Mars, Merkur) koennen hier ergaenzt werden, ohne die Komponente selbst anzupassen.
export const signCalculators: Record<SignCalculatorId, SignCalculator> = {
  venus: {
    headline: 'Venus Zeichen berechnen',
    resultLabel: 'Venuszeichen',
    minDate: '1910-01-01',
    maxDate: '2025-12-31',
    rangeLabel: '1910-2025',
    calculate: (day, month, year) => {
      const sign = findSignInYear(venusSignTable[year], day, month)
      return sign ? { sign } : null
    }
  },
  chinese: {
    headline: 'Chinesisches Sternzeichen berechnen',
    resultLabel: 'chinesisches Sternzeichen',
    minDate: '1950-02-17',
    maxDate: '2030-02-01',
    rangeLabel: '17.02.1950 bis 01.02.2030',
    calculate: findChineseSign
  }
}

export const defaultSignCalculator: SignCalculatorId = 'venus'
